import update from 'immutability-helper';
import ActionTypes from 'constants/ActionTypes';
import ColorSchemes from 'mangools-commons/dist/constants/ColorSchemes';
import { REHYDRATE } from 'redux-persist/constants';
import hasPath from 'ramda/src/hasPath';

const initialState = {
    navigatedInternally: false,
    newVersionNotificationShown: false,
    onlineStatus: true,
    colorScheme: ColorSchemes.LIGHT,
};

const miscReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.UI_MISC_NEW_VERSION_NOTIFICATION_SHOWN_SET: {
            return update(state, {
                newVersionNotificationShown: {
                    $set: true,
                },
            });
        }
        case ActionTypes.UI_MISC_NAVIGATED_INTERNALLY_SET: {
            return update(state, {
                navigatedInternally: {
                    $set: true,
                },
            });
        }
        case ActionTypes.UI_MISC_ONLINE_STATUS_SET: {
            return update(state, {
                onlineStatus: {
                    $set: action.payload.onlineStatus,
                },
            });
        }
        case ActionTypes.UI_MISC_COLOR_SCHEME_SET: {
            return update(state, {
                colorScheme: { $set: action.payload },
            });
        }
        case REHYDRATE: {
            if (hasPath(['payload', 'ui', 'misc'], action)) {
                const { misc } = action.payload.ui;
                return update(state, {
                    colorScheme: {
                        $set: hasPath(['colorScheme'], misc) ? misc.colorScheme : initialState.colorScheme,
                    },
                });
            } else {
                return state;
            }
        }
        default: {
            return state;
        }
    }
};

export default miscReducer;
